module.exports = __webpack_public_path__ + "img/cl-install-ALE-connection_12200.469ee880.png";